
/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 */
export async function insertBlockPlaceholder(editor, placeholder) {
	await editor.getAction('editor.action.insertLineAfter').run();
	const { lineNumber } = editor.getPosition();

	const range = new monaco.Range(lineNumber, 1, lineNumber, 1);

	return editor.executeEdits("insert-editor-1", [{
		identifier: 'insert',
		range,
		text: placeholder,
		forceMoveMarkers: true
	}]);
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/actions/insertBlockPlaceholder.js